import createCallException from 'utils/backend/createCallException.util';
import { fromStoreToToken } from 'utils/cognito.util';

const generateOrThrow = (token) => {
  if (token) return `Bearer ${token}`;
  throw createCallException({ message: 'No token saved!', code: 500, body: {} });
};

const determineHeaders = (options) => {
  const headers = options?.config?.headers || {};

  if (options?.authenticated) headers.Authorization = generateOrThrow(fromStoreToToken(options?.store));

  return headers;
};

export default determineHeaders;
